import React, { useState, useEffect } from "react";
import CssCodeEditor from "../../../components/CssCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const StyleTab = ({ handleLayoutChange, selectedLayout,updateAnnouncementBarTabData,announcementBarTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [barSize, setBarSize] = useState(announcementBarTabData.bar_size_type);
    const [barSizeDropdownOpen, setBarSizeDropdownOpen] = useState(false);
    const [fontType, setFontType] = useState(announcementBarTabData.font_type);
    const [fontTypeDropdownOpen, setFontTypeDropdownOpen] = useState(false);
    const [backgroundColor, setBackgroundColor] = useState(announcementBarTabData.background_color);
    const [messageColor, setMessageColor] = useState(announcementBarTabData.message_color);
    const [badgeColor, setBadgeColor] = useState(announcementBarTabData.badge_color);
    const [buttonColor, setButtonColor] = useState(announcementBarTabData.button_color);
    const [barMobileSize, setBarMobileSize] = useState(announcementBarTabData.bar_mobile_size_type);
    const [barMobileSizeDropdownOpen, setBarMobileSizeDropdownOpen] = useState(false);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(announcementBarTabData.custom_css);
    
    // Handlers Ba Size Type Change
    const handleBarSizeChange = (size) => {
        setBarSize(size);
        updateAnnouncementBarTabData("bar_size_type", size);
        setBarSizeDropdownOpen(false);
    };

    // Handlers Font Type Change
    const handleFontTypeChange = (font) => {
        setFontType(font);
        updateAnnouncementBarTabData("font_type", font);
        setFontTypeDropdownOpen(false);
    };

    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateAnnouncementBarTabData("background_color", color.hex);
    };

    // Handlers Message Color Change
    const handleMessageColorChange = (color) => {
        setMessageColor(color.hex);
        updateAnnouncementBarTabData("message_color", color.hex);
    };

    // Handlers Badge Color Change
    const handleBadgeColorChange = (color) => {
        setBadgeColor(color.hex);
        updateAnnouncementBarTabData("badge_color", color.hex);
    };

    // Handlers Button Color Change
    const handleButtonColorChange = (color) => {
        setButtonColor(color.hex);
        updateAnnouncementBarTabData("button_color", color.hex);
    };

    // Handlers Bar Mobile Size Type Change
    const handleBarMobileSizeChange = (size) => {
        setBarMobileSize(size);
        updateAnnouncementBarTabData("bar_mobile_size_type",size);
        setBarMobileSizeDropdownOpen(false);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateAnnouncementBarTabData("custom_css", code);
    };
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Bar Size</span>
                            <div className="color-pikr-box" onClick={() => setBarSizeDropdownOpen(!barSizeDropdownOpen)}>
                                <em>{barSize}</em>
                                {barSizeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Small","Medium","Large"].map((size) => (
                                            <li key={size} onClick={() => handleBarSizeChange(size)}>
                                                {size}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Font</span>
                            <div className="color-pikr-box" onClick={() => setFontTypeDropdownOpen(!fontTypeDropdownOpen)}>
                                <em>{fontType}</em>
                                {fontTypeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Default"].map((font) => (
                                            <li key={font} onClick={() => handleFontTypeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={backgroundColor} setColor={setBackgroundColor}  onChangeComplete={handleBackgroundColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Message Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={messageColor} setColor={setMessageColor}  onChangeComplete={handleMessageColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Badge Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={badgeColor} setColor={setBadgeColor}  onChangeComplete={handleBadgeColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Button Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={buttonColor} setColor={setButtonColor}  onChangeComplete={handleButtonColorChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("mobile_style_settings")}>Mobile Style Settings<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "mobile_style_settings" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Mobile Settings</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Bar Size</span>
                                <div className="color-pikr-box" onClick={() => setBarMobileSizeDropdownOpen(!barMobileSizeDropdownOpen)}>
                                    <em>{barMobileSize}</em>
                                    {barMobileSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["Small","Medium","Large"].map((size) => (
                                                <li key={size} onClick={() => handleBarMobileSizeChange(size)}>
                                                    {size}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 
        </div>
    );
};

export default StyleTab;